import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {

  constructor( private servi: ServiceService ) { }

  public getVersiones(id: any) { return this.servi.get('documentos/GetVersiones/' + id); }

  public getDocumentos() { return this.servi.get('documentos/GetListado/'); }

  public getDocumento( id: number ) { return this.servi.get('documentos/GetDocumento/' + id); }

  public getSolicitud( id: number ) { return this.servi.get('documentos/GetSolicitud/' + id); }

  public GetInfoCrear() { return this.servi.get('documentos/GetInfoCrear/'); }

  public GetListadoSolicitudes() { return this.servi.get('documentos/GetListadoSolicitudes'); }

  public publicarOcultarD(id) { return this.servi.get('documentos/PublicarOcultar/' + id); }

  public GuardarNuevaVersion( formdocumento ) {
    const formData = new FormData();
    for ( const nombre in formdocumento ) {
      if (formdocumento[nombre]) {

        if (nombre == 'facultad_id' || nombre == 'programa_id' || nombre == 'unidad_id' || nombre == 'norma_id' ||
        nombre == 'estamentos_id' || nombre == 'palabras_clave_selected') {
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < formdocumento[nombre].length; i++) {
            formData.append(nombre + '[]', formdocumento[nombre][i]);
          }
        } else {
          formData.append(nombre, formdocumento[nombre]);
        }
      }
    }
    return this.servi.postFile(`documentos/PostNuevaVersion`, formData);
  }

  public Aprobar( aprob ) {
    return this.servi.post(`documentos/AprobarSolicitud/`, aprob);
  }

  public GuardarDocumento( formdocumento ) {
    const formData = new FormData();
    for ( const nombre in formdocumento ) {
        if (formdocumento[nombre]) {

          if (nombre == 'facultad_id' || nombre == 'programa_id' || nombre == 'unidad_id' || nombre == 'norma_id' ||
          nombre == 'estamentos_id' || nombre == 'palabras_clave_selected') {
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < formdocumento[nombre].length; i++) {
              formData.append(nombre + '[]', formdocumento[nombre][i]);
            }
          } else {
            formData.append(nombre, formdocumento[nombre]);
          }
        }
      }
    return this.servi.postFile(`documentos/PostGuardar`, formData);
  }

  getServe() { return this.servi.server; }
}


